module.exports = __webpack_public_path__ + "static/media/logoSuusjePluusje.103ccf8f.webp";